import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zm-2 16l-7-8v8H5l7-8V5h7v14z"
}), 'FilterBAndWSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterBAndWSharp.js
// module id = 3628
// module chunks = 2